<template>
    <div class="invoice">
        <el-container>
            <el-main ref="main">
                <div class="titleBox">
                    <div>申请信息：</div>
                </div>
                <el-form class="dataFormBox" :inline="true" :model="dataForm">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票用途：">
                                    <el-select v-model="dataForm.billUsage" disabled placeholder="请选择发票用途">
                                        <el-option label="工程款支付" value="PROJECT_PAY"></el-option>
                                        <el-option label="费用报销" value="COST"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="项目部：">
                                    <el-select v-model="dataForm.deptName" disabled placeholder="请选择项目部">
                                        <el-option :label="deptItem.applyDeptName" :value="deptItem" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="项目名称：">
                                    <el-select v-model="dataForm.projectName" disabled placeholder="请选择项目名称">
                                        <el-option :label="projectItem.name" :value="projectItem" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="分项合同：">
                                    <el-select v-model="dataForm.subContractName" disabled placeholder="请选择分项合同">
                                        <el-option :label="subItem.name" :value="subItem" v-for="(subItem,subIndex) in subInfoList" :key="'subItem'+subIndex"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票类型：">
                                    <el-select v-model="dataForm.billType" disabled placeholder="请选择发票类型">
                                        <el-option label="增值税专用发票" value="VAT"></el-option>
                                        <el-option label="普通发票" value="PLAIN"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票种类：">
                                    <el-select v-model="dataForm.billInvoiceType" disabled placeholder="请选择发票种类">
                                        <el-option label="电子发票" value="ELECTRONIC"></el-option>
                                        <el-option label="纸质发票" value="PAPER"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票抬头：">
                                    <el-input v-model="dataForm.billHead" :readonly="true" placeholder="请输入发票抬头" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="纳税人识别号：">
                                    <el-input v-model="dataForm.taxPayerCode" :readonly="true" placeholder="请输入纳税人识别号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票号码：">
                                    <el-input v-model="dataForm.billNumber" :readonly="true" placeholder="请输入发票号码" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票代码：">
                                    <el-input v-model="dataForm.billCode" :readonly="true" placeholder="请输入发票代码" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="税率：">
                                    <el-input v-model="dataForm.taxRate" :readonly="true" placeholder="请输入税率" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票金额：">
                                    <el-input v-model="dataForm.amount" :readonly="true" placeholder="请输入发票金额" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="不含税金额：">
                                    <el-input v-model="dataForm.amountWithoutTax" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="税额：">
                                    <el-input v-model="dataForm.tax" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label-width="120px" label="附件：">
                                    <div class="inputImgBox" v-if="isShowImg">
                                        <el-image
                                                style="width: 75px;height: 45px;"
                                                :src="dataForm.billUrl"
                                                :preview-src-list="[dataForm.billUrl]">
                                        </el-image>
                                    </div>
                                    <div class="inputImgBox blueColor" v-else @click="uploadBill">下载发票附件</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                <div class="titleBox">
                    <div>其他信息：</div>
                </div>
                <el-form class="dataFormBox" :inline="true" :model="dataForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label-width="120px" label="报销审批：">
                                <el-input v-model="dataForm.approveStatusShow" :readonly="true" placeholder="请输入发票抬头" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-main>
            <el-footer class="container">
                <div class="btnMid">
                    <el-button type="info" @click="reset()">关闭</el-button>
                </div>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import {
        getInputBillService,
        getDeptListService,
        getProjectListService,
        querySubInfoByProjectIdService,
        getTempUrlService,
    } from '@/services/invoiceServices'
    import config from "@/common/config";
    import {exportExcelService2} from "../../../services/allContractServices";
    export default {
        name: "incomeInvoiceDetail",
        data(){
            return {
                dataForm:{
                    billUsage:'',
                    deptId:'',
                    deptName:'',
                    projectId:'',
                    projectName:'',
                    subContractId:'',
                    subContractName:'',
                    billInvoiceType:'',
                    billType:'',
                    billHead:'',
                    taxPayerCode:'',
                    billNumber:'',
                    billCode:'',
                    taxRate:'',
                    amount:'',
                    attachUrl:'',
                },
                activeName: 'Tab1',
                isShowImg:false,
                typeUrl: '',
                deptList:[], //项目部列表
                projectList:[], //项目列表
                subInfoList:[], //分项合同列表
                id: '',
                approveList:[],
            }
        },
        methods:{
            onActive(menuCode) {
                this.id = this.tabRouteParam.id;
                this.fileList = [];
                this.actionUrl = config.baseUrl+'/finance-web/oss/upload/finance/singleItem';
                this.getDeptList();
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                        if(this.id){
                            this.getIncomeDetail();
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取发票详情
             * */
            getIncomeDetail(){
                let params = {
                    id: this.id
                }
                getInputBillService(params).then( res => {
                    if(res.code == 10000000){
                        console.log(res)
                        this.dataForm = res.data;
                        if(res.data.attachUrl){
                            this.getTempUrl(res.data.attachUrl);
                        }
                        this.getProjectListId();
                        this.getSubInfoListId();
                        if(res.data.attachUrl){
                            this.typeUrl = res.data.attachUrl.split('.')[1];
                            this.getTempUrl(res.data.attachUrl);
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /***
             * 获取图片路径
             */
            getTempUrl(url){
                let params = {
                    filePath: url
                }
                getTempUrlService(params).then( res => {
                    if(res.code == 10000000){
                        this.dataForm.billUrl = res.data;
                        this.$nextTick(()=>{
                            if((this.typeUrl).toLowerCase() == 'jpeg' ||(this.typeUrl).toLowerCase() == 'jpg' ||
                                (this.typeUrl).toLowerCase() == 'png'|| (this.typeUrl).toLowerCase() == 'gif'){
                                this.isShowImg = true;
                            }else{
                                this.isShowImg = false
                            }
                        })
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            uploadBill(){
                if((this.typeUrl).toLowerCase() == 'pdf'){
                    window.open(this.dataForm.billUrl)
                }else{
                    exportExcelService2(this.dataForm.billUrl).then(res1 => {
                        this.$message.success('导出成功');
                    });
                }
            },

            getProjectListId(){
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            getSubInfoListId(){
                let paramsData = {
                    projectId: this.dataForm.projectId
                }
                querySubInfoByProjectIdService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.subInfoList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            reset(){
                this.bus.$emit("tabClose", "incomeInput");
                this.bus.$emit("navMenuChange", {
                    routeId: "incomeInvoice"
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
        }
        .containerBox{
            width: 1100px;
        }
    }
    /deep/.el-container .el-main{
        height: 100%;
    }
    /deep/.el-textarea{
        width: 600px;
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    /deep/.el-input.is-disabled .el-input__inner{
        background-color: #fff !important;
        color: #606266 !important;
    }
    /deep/.upload-demo{
        display: flex;
        align-items: center;
        .el-icon-close:before{
            color: #000000;
        }
        .el-upload-list__item{
            margin-top: 0px;
            margin-left: 10px;
        }
        .el-upload-list__item-name{
            margin-right: 0px;
            width: 75px;
        }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .btnMid {
        width: 300px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
    }
    .addBtn {
        width: 30px;
        height: 30px;
    }
    .dataFormBox{
        margin:30px 20px;
        .inputImgBox{
            display: flex;
            img {
                width: 75px;
                height: 45px;
                margin-right: 59px
            }
            div {
                color: rgba(25, 159, 255, 100);
                font-size: 14px;
            }
        }
        .blueColor{
            color: #409EFF;
            cursor:pointer
        }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px 0;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
</style>
